export default "__VITE_ASSET__cskXJuEO__"